import {
  POLL_GET_SUCCESS,
  POLL_GET_ERROR,
  POLL_GET_REQUESTING,
  POLL_RECEIVE_WORDS,
  POLL_ON_CHANGE,
  POLL_DELETE_WORD_REQUESTING,
  POLL_MODIFY_DEFINITION_REQUESTING,
  POLL_DELETE_WORD_SUCCESS,
  POLL_MODIFY_DEFINITION_SUCCESS,
  POLL_MODIFY_DEFINITION_ERROR,
  POLL_DELETE_WORD_ERROR,
  POLL_ANSWER,
  POLL_RECEIVED,
} from "./constants";

import { LOGOUT } from "../login/constants";
import { IPollReducer } from "./types";

const INITIAL_STATE: IPollReducer = {
  poll: {
    title: "Combien de personnes peut-on attendre ?",
    totalVotes: 9,
    receivers: [],
    options: [
      { title: "0", votes: 4 },
      { title: "3", votes: 3 },
      { title: "Plus de 4", votes: 2 },
    ],
    answers: [{ user: { _id: "" }, answer: "0" }],
  },
  requesting: false,
  error: "",
  definitionRequesting: false,
};

export default (state: IPollReducer = INITIAL_STATE, action): IPollReducer => {
  switch (action.type) {
    case POLL_DELETE_WORD_REQUESTING:
    case POLL_MODIFY_DEFINITION_REQUESTING:
      return {
        ...state,
        definitionRequesting: true,
      };

    case POLL_GET_REQUESTING:
      return {
        ...state,
        requesting: true,
        error: "",
      };

    case POLL_RECEIVED:
      return {
        ...state,
        poll: action.payload,
      };

    /*case POLL_DELETE_WORD_SUCCESS:
    case POLL_MODIFY_DEFINITION_SUCCESS:
      return {
        ...state,
        words: action.payload,
        isDefinitionVisible: false,
        definitionRequesting: false,
      };
*/
    case POLL_GET_SUCCESS:
      return {
        ...state,
        poll: action.payload,
        error: "",
        requesting: false,
      };

    case POLL_MODIFY_DEFINITION_ERROR:
    case POLL_DELETE_WORD_ERROR:
    case POLL_GET_ERROR:
      return {
        ...state,
        error: action.payload.message,
        requesting: false,
      };

    case POLL_ON_CHANGE:
      return {
        ...state,
        ...action.payload,
      };

    case POLL_ANSWER: {
      // socket emit
      const { answer, userId } = action.payload;
      const options = state.poll.options.map(el => {
        if (el.title === answer) {
          el.votes += 1;
        }
        return el;
      });
      const answers = [
        ...state.poll.answers,
        {
          user: { _id: userId },
          answer,
        },
      ];
      return {
        ...state,
        poll: {
          ...state.poll,
          options,
          answers: answers,
          totalVotes: state.poll.totalVotes + 1,
        },
      };
    }
    /*
    case POLL_RECEIVE_WORDS: {
      return {
        ...state,
        words: action.payload,
      };
    }
*/
    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
